/**
 * AOP 2027 Planning — small formatters the iteration bar and its rows share.
 */
import { formatDay } from '../internalPlayground/backfillForm';

/**
 * True in the LAST iteration (David, Oct 29 2026): "Iteration III", also with a prefix
 * ("[AOP 2027] Iteration III"). Until then a role taken out of a department is "revisited in the
 * next iteration"; in the last one there is no next, so it is "declined". The same action either
 * way (`declineDraft` → `AOP [declined]`, restorable) — only the words change.
 */
export const isFinalIteration = (name: string | null | undefined) => /\biteration\s+iii\s*$/i.test(`${name ?? ''}`.trim());

/** 'anna.kaiser@finn.com' → 'anna.kaiser' — enough to say who, without a directory lookup. */
export const who = (email: string | null | undefined) => (email ? email.split('@')[0] : 'someone');

/** 'anna.kaiser@finn.com' → 'Anna Kaiser', 'jan-erik.voss@…' → 'Jan-Erik Voss' — the name as people
 * write it, from FINN's first.last address, without a directory lookup. */
export const personName = (email: string | null | undefined) =>
  email
    ? email
        .split('@')[0]
        .split('.')
        .filter(Boolean)
        .map((part) => part.replace(/(^|-)(\p{L})/gu, (_m, dash: string, letter: string) => dash + letter.toUpperCase()))
        .join(' ')
    : 'someone';

/** Two digits, for a 'YYYY-MM-DD' built from a local date. */
const pad = (n: number) => String(n).padStart(2, '0');

/** An ISO timestamp as the page writes days elsewhere — on the LOCAL day, not the UTC one. */
export const day = (iso: string | null | undefined) => {
  const date = iso ? new Date(iso) : null;
  if (!date || Number.isNaN(date.getTime())) return '';
  return formatDay(`${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`);
};
